export default __webpack_public_path__ + "static/media/JOSA SYLLABUS_2026-27 CLASS 10.25e32e13.pdf";